var rf = require("./result_functions.js");

jQuery(document).ready(function(){

  jQuery("form[data-ajax='1']").submit(function(event){

    //disable submit
    event.preventDefault();
    var data = {};
    var uploads = false;
    var uploads_files = false;
    var id = $(this).attr('id');

    //show button spinner
    jQuery('.btn-submit .spinner-border').css('display', 'inline-block');
    //hide button text
    jQuery('.btn-submit .text').css('display', 'none');

    //add data to array
    jQuery(this).find('input, textarea, select').each(function(index){
      var name = jQuery(this).attr('name');
      var value = jQuery(this).val();
      data[name] = value;

      if(typeof window.form_files[id][name] == 'object'){
        uploads = true;

        var file = window.form_files[id][name];
        var files = file.filepond('getFiles');

        if(files.length){
          data[name] = 1;
        }

      }

    });
    
    //send ajax
    var action = jQuery(this).attr('action');
    var method = jQuery(this).attr('method');
    var success_function = jQuery(this).attr('data-success-function');
    var before_send_function = jQuery(this).attr('data-before-send-function');
    var complete_function = jQuery(this).attr('data-complete-function');
    var validation_error_function = jQuery(this).attr('data-validation-error-function');
    var form = jQuery(this);
    form_clear_invalid_fields(form);

    //set action
    data['action'] = action;

    if(before_send_function){
      rf[before_send_function](form, data);
    }

    var request = jQuery.ajax({
      url: ge.ajaxurl,
      method: method,
      data: data,
      dataType: "json"
    });

    request.done(function(data) {

      if(complete_function){
        rf[complete_function](form, data);
      }

      //call function from data
      if(data.status === 'success'){

        // exist upload fields
        if(uploads){

          for(var propertyName in window.form_files[id]) {
    
            var file = window.form_files[id][propertyName];
            var files = file.filepond('getFiles');
    
            //upload fields selected files
            if(files.length){

              uploads_files = true;

              file.filepond('processFile').then(file => {
                // File has been processed
                console.log("processed");

                hide_spinner();

                rf[success_function](form, data);
              });
              
              file.on('FilePond:error', function(e) {

                console.log('Error', e);

                hide_spinner();

              });

            }
            else{
              rf[success_function](form, data);
            }

          }
        }
        else{
          rf[success_function](form, data);
        }

      }
      if(data.status === 'validation_error'){

        if(validation_error_function != undefined && validation_error_function != ""){
          rf[validation_error_function](form, data);
        }
        else{
          console.log(data.errors);
          form_validation_error(form, data.errors);
        }
      }

    });
    request.fail(function( jqXHR, textStatus ) {
      console.log( "Request failed: " + textStatus );
    });
    request.always(function( jqXHR, textStatus ) {

      if(!uploads_files){
        hide_spinner()
      }

    });

  });

});

hide_spinner = function(){
  //hide button spinner
  jQuery('.btn-submit .spinner-border').css('display', 'none');
  //show button text
  jQuery('.btn-submit .text').css('display', 'inline');
}



// WEBPACK FOOTER //
// ./assets/js/ajax.js